import {observable} from 'mobx'

export default class MarketBonusCardDiscount {
    /** @type {string} */
    @observable discount_id = ''
    /** @type {boolean} */
    @observable is_enabled = false
    @observable description = ''
    @observable url = ''
    /** @type {Date|null} */
    @observable start_date = null
    /** @type {Date|null} */
    @observable end_date = null

    constructor(discount) {
        if (discount) {
            this.discount_id = discount.discount_id
            this.is_enabled = discount.is_enabled
            this.description = discount.description
            this.url = discount.url
            this.start_date = this._tryCreateDate(discount.start_date)
            this.end_date = this._tryCreateDate(discount.end_date)
        }
    }

    /**
     * @param value
     * @return {Date|null}
     * @private
     */
    _tryCreateDate(value) {
        if (typeof value === 'string') {
            const date = new Date(value)

            return isNaN(date)
                ? null
                : date
        } else if (value instanceof Date) {
            return new Date(value)
        } else {
            return null
        }
    }
}